<template>
  <path
    d="M6.94286 3.04444L11.8773 5.60306C13.6617 6.52828 14.5538 6.99088 14.7057 7.67487C14.7533 7.88902 14.7533 8.11098 14.7057 8.32513C14.5538 9.00912 13.6617 9.47172 11.8773 10.3969L6.94286 12.9556C5.38894 13.7613 4.61198 14.1642 3.99792 13.946C3.80415 13.8772 3.6266 13.7693 3.47629 13.6289C3 13.1842 3 12.309 3 10.5586V5.44138C3 3.69099 3 2.81579 3.47629 2.37106C3.6266 2.23072 3.80415 2.12279 3.99792 2.05396C4.61198 1.83584 5.38894 2.23871 6.94286 3.04444Z"
    fill="currentColor" />
</template>
